import * as React from "react"

const IamPartnersIconMenu: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    width="32"
    height="32"
    enableBackground="new 0 0 70 70"
    viewBox="0 0 32 32"
  >
    <linearGradient
      id="SVGID_1_"
      x1={16}
      x2={16}
      y1={34}
      y2={2}
      gradientTransform="matrix(1 0 0 -1 0 34)"
      gradientUnits="userSpaceOnUse"
    >
      <stop
        offset={0}
        style={{
          stopColor: "#0062ff",
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: "#004bc2",
        }}
      />
    </linearGradient>
    <path
      d="M6.6 0h18.7C29 0 32 3 32 6.6v18.7c0 3.7-3 6.6-6.6 6.6H6.6C3 32 0 29 0 25.4V6.6C0 3 3 0 6.6 0z"
      style={{
        fill: "url(#SVGID_1_)",
        fillOpacity: 0.1,
      }}
    />
    <path
      d="m12.9 19.7.6-.3c.2-.1.3-.5.2-.7l-1.1-2c-.1-.2-.3-.3-.4-.3-.1 0-.2 0-.3.1l-.6.3c-.1 0-.2.1-.3.1-.3 0-.5-.2-.5-.5v-.7c0-.3-.2-.5-.5-.5H7.7c-.3 0-.5.2-.5.5v.7c0 .3-.2.5-.5.5-.1 0-.2 0-.3-.1l-.6-.3c-.1 0-.2-.1-.3-.1-.2 0-.3.1-.4.3l-1.1 2c-.1.2-.1.6.2.7l.6.3c.3.2.3.7 0 .9l-.6.3c-.2.1-.3.5-.1.7l1.1 2c.1.2.3.3.4.3.1 0 .2 0 .3-.1l.6-.3c.1 0 .2-.1.3-.1.3 0 .5.2.5.5v.7c0 .3.2.5.5.5H10c.3 0 .5-.2.5-.5v-.7c0-.3.2-.5.5-.5.1 0 .2 0 .3.1l.6.3c.1 0 .2.1.3.1.2 0 .3-.1.4-.3l1.1-2c.1-.2.1-.6-.2-.7l-.6-.3c-.3-.2-.3-.7 0-.9zm-4 1.9c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5zM12.5 5.7c-.3-.3-.7-.3-1 0-.3.3-.3.7 0 1l1.2 1.2c-4.6.2-8.3 3.8-8.7 8.3l.1-.2c.3-.5.8-.8 1.4-.8.8-3.3 3.6-5.7 7.1-5.9l-1.2 1.2c-.3.3-.3.7 0 1 .1.1.3.2.5.2s.4-.1.5-.2l2.4-2.4c.1-.1.2-.3.2-.5s-.1-.4-.2-.5c.1 0-2.3-2.4-2.3-2.4zM21.3 9.3c1.5 0 2.8-1.3 2.8-2.8 0-1.5-1.3-2.8-2.8-2.8S18.5 5 18.5 6.5s1.3 2.8 2.8 2.8zM26.8 16.8V13c0-1.1-.7-2-1.7-2.3l-1.5-.2c-.1 0-.3 0-.3.2l-1.7 4.6c-.1.3-.5.3-.6 0l-1.7-4.6c0-.1-.1-.2-.2-.2l-1.6.3c-1 .3-1.7 1.3-1.7 2.4V17c0 .6.5 1 1 1h8.8c.7-.1 1.2-.6 1.2-1.2zM28 17.8c-.1.8-.7 1.3-1.5 1.3-.6 3.5-3.6 6.2-7.2 6.4l1.2-1.2c.3-.3.3-.7 0-1-.3-.3-.7-.3-1 0l-2.4 2.4c-.3.3-.3.7 0 1l2.4 2.4c.1.1.3.2.5.2s.4-.1.5-.2c.3-.3.3-.7 0-1l-1.2-1.2c4.8-.2 8.7-4.2 8.7-9.1z"
      fill="#052351"
    />
    <path
      d="M21.9 10.3c-.1-.1-.2-.1-.3-.1H21c-.1 0-.2 0-.3.1-.1.1-.1.3 0 .4l.4.6-.2 1.5.4.9c0 .1.2.1.2 0l.4-.9-.2-1.5.4-.6c-.1-.1-.1-.2-.2-.4z"
      fill="#052351"
    />
  </svg>
)
export default IamPartnersIconMenu
